import { render, staticRenderFns } from "./HeaderSide.vue?vue&type=template&id=286f0b73&"
import script from "./HeaderSide.vue?vue&type=script&lang=js&"
export * from "./HeaderSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports